module.exports = __webpack_public_path__ + "static/ml_hero_platform-1d027554a95e3a5cd6b1f1d79d2ad1df.png";